var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"dense":"","outlined":"","return-object":"","item-text":"name","items":_vm.groupList,"label":_vm.$t('planning.groupBy'),"prepend-inner-icon":"mdi-select-group"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }